/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @version 1.3.0
 * @since 1.3.0
 */

import { useEffect } from 'react';

import { withRouter } from 'react-router';

const ScrollToTop = (props: any) => {
    const { pathname } = props.location;

    useEffect(() => {
        try {
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
        } catch (error) {
            window.scrollTo(0, 0);
        }
    }, [pathname]);

    return null;
};

export default withRouter(ScrollToTop);
